import { print } from 'graphql';
import { gql } from 'graphql-tag';

import { AdditionalFields } from '../../models/models';
import { getDateModified, getRoleForMutation } from '../../utilities/utilityFunctions';
import { defaultDoc, getValueFromLocalStorage } from '../share/defaultDoc';
import type {
  DeficiencyComponentRemoval,
  DeficiencyComponentRemovalDocument,
} from './deficiencyComponentRemoval.types';

export const deficiencyComponentRemovalPullQueryBuilder = (
  document: DeficiencyComponentRemoval,
) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }

  const query = print(gql`
    query mobileComponentRemoval(
      $siteId: Int!
      $disciplineId: Int!
      $lastModified: DateTime!
      $isLeadInspector: Boolean!
    ) {
      mobileComponentRemoval(
        siteId: $siteId
        disciplineId: $disciplineId
        lastModified: $lastModified
        isLeadInspector: $isLeadInspector
      ) {
        deficiencyId
        deficiencyUUID
        inspectionId
        isActive
        comment
        componentRemovalId
        parentComponentId
        parentComponentName
        componentRemovalIdBySC
        commentBySC
        siteId
        disciplineId
        dateCreated
        dateModified
        assetId
        componentVersionInspectionId
        componentVersionId
        componentVersionUUId
      }
    }
  `);

  return {
    query,
    variables: {
      siteId: JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
      disciplineId: JSON.parse(getValueFromLocalStorage('selectedDiscipline'))
        ?.selectedDisciplineId,
      lastModified: getDateModified(
        doc?.dateModified,
        doc?.dateCreated,
        doc.siteId,
        doc.disciplineId,
        JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
        JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
      ),
      isLeadInspector: getValueFromLocalStorage('isLeadInspector') === 'True',
    },
  };
};

export const deficiencyComponentRemovalPushQueryBuilder = (doc: DeficiencyComponentRemoval[]) => {
  const document = doc[0];
  const query = print(gql`
    mutation saveMobileComponentRemoval(
      $mobileComponentRemovalInput: GetMobileComponentRemovalInput
      $role: Int!
    ) {
      saveMobileComponentRemoval(
        mobileComponentRemoval: $mobileComponentRemovalInput
        role: $role
      ) {
        assetInsepctionComponentFailureId
      }
    }
  `);
  const { ...data } = document;
  const role = getRoleForMutation(data);

  const variables = {
    mobileComponentRemovalInput: data,
    role,
  };

  return {
    query,
    variables,
  };
};

export const deficiencyComponentRemovalPushModifier = (doc: DeficiencyComponentRemovalDocument) => {
  const obj: AdditionalFields = {
    ...doc,
  };
  const blackListedProp = [
    '_attachments',
    '_rev',
    '_deleted',
    'dateCreated',
    'dateModified',
    '_meta',
    'isDeleted',
  ];
  blackListedProp.forEach(property => {
    obj[property as keyof AdditionalFields] = undefined;
  });
  return obj;
};
